import React, { useEffect, useState, useRef } from "react";
import { User, LogOut, Menu } from "lucide-react";
import { getClientByNetwork } from "../api/clients-api";
import LoadingSkeleton from "./general/skeleton";
import { useAuth } from "../context/authContext";

export const NavBar = ({
  currentScreen,
  showSidebar,
  setShowSidebar,
  hideSidebarToggle = false,
}) => {
  const { user, NETWORK, logout } = useAuth();
  const [client, setClient] = useState("");
  const [dataLoading, setDataLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const fetchProfileData = async (network) => {
    try {
      setDataLoading(true);
      const response = await getClientByNetwork(network);
      setClient(response.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (user && NETWORK && NETWORK !== "unassigned") {
      fetchProfileData(NETWORK);
    } else {
      setClient("");
    }
  }, [user, NETWORK]);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const subtitles = {};
  const displayName = user?.email?.split("@")[0] || "Admin";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setTimeout(() => setIsOpen(false), 300);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="sticky top-0 bg-white px-6 py-4 flex justify-between items-center rounded-2xl z-30">
      {/* Hamburger for mobile only */}
      <div className="flex items-start gap-2">
        {!hideSidebarToggle && (
          <button
            className="lg:hidden"
            onClick={() => setShowSidebar(!showSidebar)}
          >
            <Menu size={28} className="text-primary-dark" />
          </button>
        )}
        <div className="mt-1">
          {currentScreen === "Dashboard" ? (
            <>
              <p className="font-nexa text-sm text-subText m-0">Welcome back</p>
              <h2 className="text-lg font-semibold m-0">{displayName}</h2>
            </>
          ) : (
            <h2 className="text-lg font-semibold m-0">{currentScreen}</h2>
          )}
          {subtitles[currentScreen] && (
            <p className="font-nexa text-sm text-subText m-0">
              {subtitles[currentScreen]}
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-4">
        {/* <Moon size={30} className="cursor-pointer hover:text-subText transition text-primary-dark" /> */}
        {/* <Bell size={30} className="cursor-pointer hover:text-subText transition text-primary-dark" /> */}
        {/* <Settings size={30} className="cursor-pointer hover:text-subText transition text-primary-dark" /> */}
        <div className="flex gap-3 items-center">
          <div className="items-center">
            <LoadingSkeleton loading={dataLoading} className={"h-10 w-20"}>
              <p className="font-nexa font-bold text-lg text-right text-primary-dark leading-5 mb-0">
                {client?.name}
                <br />
                <span className="font-nexa text-sm text-right text-subText leading-5 mt-0">
                  {displayName}
                </span>
              </p>
            </LoadingSkeleton>
          </div>
          <User
            size={30}
            className="text-primary-dark cursor-pointer hover:text-subText"
            onClick={toggleMenu}
          />
        </div>
      </div>
      {/* Dropdown Menu */}
      {isOpen && (
        <div
          ref={menuRef}
          className="absolute right-5 mt-0 w-auto bg-white shadow-lg rounded-lg z-50 p-0"
        >
          <ul className="p-0 pt-3">
            <li
              className="w-52 px-4 py-3 cursor-pointer flex items-center gap-2 hover:bg-lightGray"
              onClick={() => logout()}
            >
              <LogOut size={18} className="text-error" />
              Logout
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};
